const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || "DEVELOPMENT";

interface EnvConfig {
  API_BASE_URL: string;
  LABEL: string;
}

const ENV_CONFIG: Record<string, EnvConfig> = {
  DEVELOPMENT: {
    API_BASE_URL: "",
    LABEL: "Development",
  },
  TEST: {
    API_BASE_URL: "",
    LABEL: "Test",
  },
  PRODUCTION: {
    API_BASE_URL: "",
    LABEL: "Production",
  },
};

const config = ENV_CONFIG[ENVIRONMENT] || ENV_CONFIG.DEVELOPMENT;

export default config;
export { ENVIRONMENT };
